import appleWatchNike from '@/assets/device-icons/apple-watch-nike.svg';

interface AppleWatchNikeIconProps {
  className?: string;
}

export const AppleWatchNikeIcon = ({ className = "h-5 w-5" }: AppleWatchNikeIconProps) => {
  return (
    <img 
      src={appleWatchNike} 
      alt="Apple Watch Nike" 
      className={className}
    />
  );
};
